import { get } from 'lodash'
import { leadActionsSlice } from 'Pages/lead'
import { NOTIFICATION_TYPE } from 'Modules'
import { ChannelHandler, SocketMessage, SocketMessageTypes } from 'Modules/Socket'
import { Callback } from 'Src/types/utilTypes'
import { oldUserSlice, userSlice } from 'Pages/user'

export class LeadChannel implements ChannelHandler {
	public constructor(private readonly dispatch: Callback) {
		this.dispatch = dispatch
	}

	public work(data: SocketMessage) {
		const type = get(data?.message, 'type', null)
		const id = get(data?.message, 'payload.lead_id', null)
		const fio = get(data?.message, 'payload.fio', '')
		if (type === SocketMessageTypes.LEAD_COMPLETE && id) {
			const inn = get(data?.message, 'payload.inn', '')
			this.dispatch(leadActionsSlice.actions.pushLeadSocketId({ id, fio, inn }))
		}
		if (type === SocketMessageTypes.LEAD_AGREEMENT_EXPIRED && id) {
			const notify = {
				type: NOTIFICATION_TYPE.INFO,
				message: 'Версия согласия изменилась, необходимо получить новое',
			}
			this.dispatch(leadActionsSlice.actions.pushLeadSocketId({ id, fio, notify }))
		}
		if (type === SocketMessageTypes.USER_LEAD_COMPLETE) {
			const notify = {
				type: NOTIFICATION_TYPE.SUCCESS,
				message: `${fio} подтвердил(а) согласие по email`,
			}
			this.dispatch(oldUserSlice.actions.setUpdated(true))
			this.dispatch(leadActionsSlice.actions.pushLeadSocketId({ id, fio, notify }))
			this.dispatch(userSlice.actions.completeLeadSocket())
		}
	}
}
